import { Injectable } from "@angular/core";
import { ID } from '@common/interfaces/id';
import { IID_GENERIC_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IID_Generic_KoState extends EntityState<IID_GENERIC_KO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_GENERIC_KO })
export class IID_Generic_KoStore extends EntityStore<IID_Generic_KoState> {
  constructor() {
    super([]);
  }
}
